import React, { useState } from 'react';
import img1 from '../../Assets/About/about-1.jpg'
import img2 from '../../Assets/About/about-2.jpg'
import img3 from '../../Assets/About/about-3.jpg'


export default function AboutHero1() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-8 sm:py-10 md:py-12 lg:py-16">
      <div className="w-full flex flex-col lg:flex-row items-center lg:items-start gap-6">
        
        {/* Left Side - Images Section */}
           <div className="relative flex items-center justify-center gap-2 md:gap-4 w-full lg:max-w-[45%] ">
          {/* Left Image Grid */}
          <div className='max-h-[620px] space-y-4'>
            <img src={img3} alt="" className='rounded-t-xl' />
            <img src={img2} alt="" className='rounded-b-xl' />
          </div>

          {/* Right Main Image */}
        <div className='max-h-[620px]  '>
            <img src={img1} alt="" className='rounded-xl' />
        </div>

          {/* Center Rotating Badge */}
          <div 
            className="absolute right-16 top-1/2 sm:left-[55%] sm:-translate-x-1/2 sm:-translate-y-1/2 z-10"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div 
              className={`w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-purple-600 via-fuchsia-600 to-pink-600 shadow-2xl flex items-center justify-center transition-transform duration-300 ${
                isHovered ? 'scale-110' : 'scale-100'
              }`}
              style={{
                animation: 'rotate 8s linear infinite, pulse 2s ease-in-out infinite',
              }}
            >
              <div className="absolute inset-4 rounded-full bg-gradient-to-br from-purple-500 to-fuchsia-500 flex items-center justify-center">
                <div className="text-white text-center transform -rotate-0">
                  <div 
                    className="text-xs font-bold tracking-wider mb-1"
                    style={{
                      animation: 'counterRotate 8s linear infinite',
                    }}
                  >
                    AWARD WINNING
                  </div>
                  <div 
                    className="flex items-center justify-center gap-1"
                    style={{
                      animation: 'counterRotate 8s linear infinite',
                    }}
                  >
                    {/* <span className="text-lg">★</span>
                    <span className="text-lg">★</span> */}
                  </div>
                  <div 
                    className="text-xs font-bold tracking-wider mt-1"
                    style={{
                      animation: 'counterRotate 8s linear infinite',
                    }}
                  >
                                     </div>
                </div>
              </div>
              
              {/* Outer rotating text */}
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 128 128">
                <defs>
                  <path
                    id="circlePath"
                    d="M64,64 m-50,0 a50,50 0 1,1 100,0 a50,50 0 1,1 -100,0"
                  />
                </defs>
                <text className="text-[8px] fill-white font-bold tracking-widest">
                  <textPath href="#circlePath" startOffset="0%">
                    AWARD WINNING • COMPANY • 
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
        </div>



        {/* Right Side - Content Section */}
        <div className="w-full lg:w-[45%] xl:w-[50%] space-y-4 sm:space-y-5 md:space-y-6 text-center lg:text-left px-2 sm:px-0">
          
          {/* Main Heading */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl font-bold leading-tight">
            <span className="block mb-1 sm:mb-2">
              The Advantages Of
            </span>
            <span className="block mb-1 sm:mb-2 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Collaborating With An
            </span>
            <span className="block">
              AI Agency
            </span>
          </h1>

          {/* Subheading and Description */}
          <div className="space-y-3 sm:space-y-4">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              AI agencies may assist in developing AI-driven products
            </h2>
            <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed">
              An AI agency is a business or organization that specializes in leveraging artificial
              intelligence to provide solutions and services to clients. These agencies
              typically offer expertise in areas like machine learning.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
            {/* Card 1 */}
            <div className="group bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-purple-100">
              <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mb-3">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-purple-100 to-fuchsia-100 rounded-xl sm:rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  <svg className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 text-center sm:text-left">
                  Innovate with AI
                </h3>
              </div>
              <p className="text-gray-600 text-sm sm:text-base">
                Utilize AI tools to analyze customer behavior, improve customer sales.
              </p>
            </div>

            {/* Card 2 */}
            <div className="group bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-purple-100">
              <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mb-3">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-purple-100 to-fuchsia-100 rounded-xl sm:rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  <svg className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 text-center sm:text-left">
                  Maximize AI Impact
                </h3>
              </div>
              <p className="text-gray-600 text-sm sm:text-base">
                Prior to joining company, she spent 20+ years at Inmosys, where he.
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-4 pt-2">
            <button className="group relative px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 text-white font-bold rounded-full overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 text-sm sm:text-base w-full sm:w-auto">
              <span className="relative z-10">DISCOVER MORE</span>
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
            
            <button className="group w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-400 rounded-full hidden md:flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110 flex-shrink-0">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes counterRotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }

        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 0 20px rgba(168, 85, 247, 0.4);
          }
          50% {
            box-shadow: 0 0 40px rgba(168, 85, 247, 0.8);
          }
        }
      `}</style>
    </div>
  );
}